// extracted by mini-css-extract-plugin
export default {"filtersLabel":"styles_filtersLabel__Sj7jd"};